import { Route, Routes, useLocation, BrowserRouter } from "react-router-dom";

import Navbar from "./Webpage/navbar.js";
import Footer from "./Webpage/footer.js";
import ScrollToTop from "./Webpage/utils/ScrollToTop.js";
import AccessManagementPage from "./Webpage/AccessManagementPage.js";
import Landingpage from "./Webpage/Landingpage.js";
import FeedbackDashboard from "./Webpage/feedbackpage.js";
import Broadcast from "./Webpage/Broadcast.js";
import { SignIn } from "./Webpage/SignIn.js";
import { KPIDashboard } from "./Webpage/Kpidetails.js";
import KmFeedback from "./Webpage/KmFeedback.js";
import TransDash from "./Webpage/TransDash.js";
import KMFilterDash from "./Webpage/KM_Filters.js";
import OutagePage from "./Webpage/Outage.js";
import BroadcastReport from "./Webpage/BroadcastReport.js";

const HIDE_LAYOUT_ROUTES = ["/"];

function Layout() {
  const location = useLocation();
  const hideLayout = HIDE_LAYOUT_ROUTES.includes(location.pathname);

  return (
    <div className="App">
      {!hideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/broadcastmessage" element={<Broadcast />} />
        <Route path="/dashboard" element={<h1>This is for dashboard</h1>} />
        <Route path="/kpidetails" element={<KPIDashboard />} />
        <Route path="/profile" element={<h1>Profile</h1>} />
        <Route path="/feedback" element={<FeedbackDashboard />} />
        <Route path="/kmanalysis" element={<KmFeedback />} />
        <Route path="/transcript" element={<TransDash />} />
        <Route path="/kmfilter" element={<KMFilterDash />} />
        <Route path="/outage-info" element={<OutagePage />} />
        <Route path="/BroadcastReport" element={<BroadcastReport />} />
        <Route path="/accessmanagement" element={<AccessManagementPage />} />
        <Route path="/landingpage" element={<Landingpage />} />


        {/* ✅ Fallback route */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>

      {/* {!hideLayout && <Footer />} */}
      <ScrollToTop />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}